module.exports = __webpack_public_path__ + "img/kannyn.afc631e2.jpg";